import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '@/router'
import { store } from './store'
import config from '@/../config'

// still has stuff to remove from here

if (localStorage.getItem('auth_token')) {
	axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');
}

axios.interceptors.response.use(config => {
	return config
}, 
	(error) => {
	if(error.request.status === 401 || error.request.status === 422){
		localStorage.clear();
		delete axios.defaults.headers.common['Authorization'];
		router.push({ name: 'Login', query: { expiredSession: true } });
  }
  return Promise.reject(error);
})




// WEBPACK FOOTER //
// ./src/axios.settings.js